import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useSelector } from "react-redux";

import LogoIcon from "../../assets/logo.svg";
import { ProfileMenu } from "./ProfileMenu";
import { Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    logo: {
        height: "40px",
        paddingTop: "2px",
        marginTop: "8px",
    },
    logoWrapper: {
        flexGrow: 1,
        color: "#6590B9",
    },
    appBar: {
        background: "white",
        color: "black",
        zIndex: theme.zIndex.drawer + 1,
    },
}));

export const PageHeader = () => {
    const classes = useStyles();
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);

    const authStates = useSelector((state) => state.auth);
    const { user } = authStates?.fetchUserState;

    const workspaceStates = useSelector((state) => {
        return state.workspaces;
    });
    const { active_workspace } = workspaceStates?.logintoWorkspaceState;
    const { workspaces } = workspaceStates?.fetchWorkspacesState;

    React.useEffect(() => {
        if (user) {
            setIsLoggedIn(true);
        } else setIsLoggedIn(false);
    }, [user]);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Box component="div" className={classes.logoWrapper}>
                        <img src={LogoIcon} className={classes.logo} />
                    </Box>
                    {isLoggedIn && (
                        <>
                            <Typography typography={"menu6"}>
                                Workspace: {active_workspace?.name}
                            </Typography>
                            <ProfileMenu
                                user={user?.user}
                                active_workspace={active_workspace}
                                workspaces={workspaces}
                                logout={() => {
                                    window.location.href =
                                        window.account.API_HOST +
                                        "/api/auth/logout/";
                                }}
                            />
                        </>
                    )}
                </Toolbar>
            </AppBar>
        </Box>
    );
};
